// 🔧 event_voting_type_helpers.js
// ✅ Purpose: Helper functions for reading event-level voting type safely
// ✅ Features:
// - Treats missing votingType as "standard" for older events
// - Keeps voting type checks consistent across the app
// - Prevents public voting pages from breaking if event data is incomplete
// - Provides simple helper checks for Standard voting
// - Sets the foundation for future voting types like ranked choice and points-based voting

import {
  DEFAULT_VOTING_TYPE,
  getSafeVotingType,
} from "./voting_types";

// ✅ Safely returns the event voting type
// ✅ Older events without votingType automatically become "standard"
export const getEventVotingType = (eventData) => {
  return getSafeVotingType(eventData?.votingType || DEFAULT_VOTING_TYPE);
};

// ✅ Simple helper for checking whether an event uses the current built-in voting model
export const isStandardVotingEvent = (eventData) => {
  return getEventVotingType(eventData) === "standard";
};

// ✅ Simple helper for checking whether an event uses ranked choice voting
export const isRankedChoiceVotingEvent = (eventData) => {
  return getEventVotingType(eventData) === "ranked_choice";
};

// ✅ Simple helper for checking whether an event uses points-based voting
export const isPointsVotingEvent = (eventData) => {
  return getEventVotingType(eventData) === "points";
};

// ✅ Simple helper for checking whether an event uses scorecard voting
export const isScorecardVotingEvent = (eventData) => {
  return getEventVotingType(eventData) === "scorecard";
};